// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import { COLORS } from "shared/utils/styles"
import { HEADER_HEIGHT } from "shared/components/header/styles"

const container = css`
  display: flex;
  justify-content: center;
  height: 100vh;
`

const document = css`
  background-color: white;
  overflow: hidden;
  width: 100%;
`

const main = css`
  display: flex;
  flex-direction: row;
  height: 100%;
`

const sideBar = css`
  border: 0px solid ${COLORS.CEDEDED};
  border-right-width: 1px;
  max-width: 480px;
  width: 22.5%;
`

const content = css`
  height: calc(100% - ${HEADER_HEIGHT}px);
  overflow: auto;
  width: 77.5%;
`

export { container, document, main, sideBar, content }
